import { useNav } from '../../../hooks/useNav'
import { bookService } from '../../../service/BookService'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
} from '../../../utils/showToast'
import { bookKeys, MODE } from '../../../data/queryFactories'
import { PATH } from '../../../data/router_path'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import BookForm from '../../../features/book-management/book-list/components/BookForm'
import { uploadAndEditBookDTO } from '../../../features/book-management/book-list/BookDataMapping'
import { bookBorrowService } from '../../../service/BookBorrowService'

const CreateBookPage = () => {
  const navigate = useNav()
  const queryClient = useQueryClient()

  const createBookMutation = useMutation({
    mutationFn: async (data) => {
      const { pdfFile, cover, bookInfo } = data
      const submitData = uploadAndEditBookDTO({
        ...bookInfo,
        status: 'ACTIVE',
      })
      if (!pdfFile) {
        throw new Error('Chưa tải file sách')
      }
      //create book file submit pdf, and cover file
      const result = await bookService.create({
        payload: submitData,
        pdf: pdfFile,
        cover: cover,
      })
      if (!result.success) {
        throw new Error(result.message.content)
      }

      const bookUuid = result.data.bookInfoDtoOut.uuid
      //validate pdf and cover file
      const pdfValidation = await bookService.validatePdfExists(bookUuid)
      if (!pdfValidation.success) {
        throw new Error('Tải file sách thất bại')
      }

      if (cover) {
        const coverValidation = await bookService.validateCoverExists(bookUuid)
        if (!coverValidation.success) {
          throw new Error('Tải ảnh bìa thất bại')
        }
      }
      // create borrow book
      if (bookInfo.numOfBorrow && bookInfo.timeOfBorrow) {
        await bookBorrowService.create({
          bookId: bookUuid,
          numOfBorrow: bookInfo.numOfBorrow,
          timeOfBorrow: bookInfo.timeOfBorrow,
        })
      }

      // assign book collections
      if (bookInfo.bookCollections && bookInfo.bookCollections.length > 0) {
        const assignResult = await bookService.assignCollections({
          book: bookUuid,
          collections: bookInfo.bookCollections,
        })
        if (!assignResult.success) {
          throw new Error('Failed to assign book collections')
        }
      }

      return { result }
    },
    onMutate: () => showLoadingToast('Đang tải sách lên hệ thống...'),
    onError: (error) => {
      console.log(error, 'error')
      showErrorToast({ message: error.message })
    },
    onSuccess: () => {
      showSuccessToast('Tạo một cuốn sách thành công')
      queryClient.invalidateQueries({ queryKey: bookKeys.all })
      navigate(PATH.BOOK.LIST)
    },
  })

  return (
    <BookForm
      mode={MODE.CREATE}
      initForm={{
        publisher: 'NXB Đại học Kinh tế Quốc dân',
        publishYear: new Date().getFullYear().toString(),
        price: '0',
      }}
      initPdf={null}
      initCover={null}
      initPdfInfo={null}
      submitHandler={(pdfFile, cover, formData) => {
        createBookMutation.mutate({
          pdfFile,
          cover,
          bookInfo: formData,
        })
      }}
    />
  )
}
export default CreateBookPage
